import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-course-library',
  templateUrl: './course-library.component.html',
  styleUrls: ['./course-library.component.scss']
})
export class CourseLibraryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
